import React, { useState } from "react";
import { Dropdown, Radio, Space, ConfigProvider } from "antd";
import * as Icons from "assets/icons";
import useThemeStore from "(store)/themeStore";

const SortDropdown = ({
  sortOptions,
  propertyType = false,
  additionalFilters = {},
  onSortChange,
  sortName = true,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const theme = useThemeStore((state) => state.theme);
  const [selectedSort, setSelectedSort] = useState(sortOptions[0].value);

  const handleSortChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedSort(selectedValue);
    onSortChange(selectedValue); // <-- Pass the selected value to the parent
  };
  const generateMenuItems = () => {
    let items = [];

    // Sort By Section
    items.push({
      key: "sort-by-title",
      label: (
        <strong className="block text-sm font-normal text-gray-400">
          SORT BY:
        </strong>
      ),
      type: "group",
    });

    items.push({
      key: "sort-options",
      label: (
        <Radio.Group
          name="sort"
          className="block"
          value={selectedSort} // <-- Bind selected value
          onChange={handleSortChange} // <-- Handle change
        >
          {sortOptions.map((option, index) => (
            <Radio
              value={option.value}
              key={`sort-${index}`}
              className="text-black dark:text-white flex flex-row-reverse py-[2px] hover:bg-[#f5f5f5] dark:hover:bg-gray-600 rounded-md pr-2"
            >
              <span className="flex w-[20vh]">{option.label}</span>
            </Radio>
          ))}
        </Radio.Group>
      ),
    });

    if (propertyType && additionalFilters.propertyType) {
      items.push({
        key: "property-type-divider",
        type: "divider",
      });

      items.push({
        key: "property-type-title",
        label: (
          <strong className="block text-sm font-normal text-gray-400">
            {additionalFilters.propertyType.title}
          </strong>
        ),
        type: "group",
      });

      items.push({
        key: "property-type-options",
        label: (
          <Radio.Group
            name="propertyType"
            className="block"
            value={selectedSort} // <-- Bind selected value
            onChange={handleSortChange} // <-- Handle change
          >
            {additionalFilters.propertyType.options.map((type, index) => (
              <Radio
                value={type.value}
                key={`type-${index}`}
                className="text-black dark:text-white flex flex-row-reverse py-[2px]"
              >
                <span className="flex w-[20vh]">{type.label}</span>
              </Radio>
            ))}
          </Radio.Group>
        ),
      });
    }

    return items;
  };

  const menu = {
    items: generateMenuItems(),
    className:
      "p-4 border dark:border-gray-800 bg-white rounded-lg shadow-lg no-hover-bg",
  };

  const handleOpenChange = (open) => {
    setIsOpen(open); // Track the dropdown open state
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Dropdown: {
            zIndexPopupBase: 9999,
            colorText: "black",
            colorBorder: "gray",
            colorBgElevated: theme === "dark" ? "#1f1f1f" : "white",
          },
          Radio: {
            colorPrimary: "#1996a6",
            colorPrimaryHover: "#1996a6",
            colorText: "black",
          },
        },
      }}
    >
      <Dropdown
        menu={menu}
        trigger={["click"]}
        onOpenChange={handleOpenChange} // Handle open/close state
        className={`border rounded-lg ${
          isOpen ? "border-[#2397a5]" : "border-gray-300 dark:border-gray-800"
        } hover:border-[#2397a5] hover:ring-[#2397a5] hover:outline-none`}
      >
        <div className="cursor-pointer flex items-center">
          <Space
            className={` ${sortName ? "py-[6px] px-4" : "py-[2px] px-1"} `}
          >
            <span className="bg-gray-500 dark:text-white">
              <Icons.SortIcon
                width={sortName ? "25px" : "15px"}
                height={sortName ? "25px" : "15px"}
                color={
                  isOpen
                    ? "#2397a5"
                    : theme === "dark"
                    ? "#d1d5db"
                    : "#91919280"
                }
              />
            </span>
            {sortName && (
              <span className="text-gray-500 text-[1em] dark:text-white mt-1">
                Sort
              </span>
            )}
          </Space>
        </div>
      </Dropdown>
    </ConfigProvider>
  );
};

export default SortDropdown;
